export const quickFilters = ["All","Approved","Approval Pending",]

export const tourType = [
          "Field Work",
          "Meeting",
          "Campaign",
          "Transit",
          "Office Work/Admin",
          "Training/Induction",
          "Sales Closing",
          "leave",
          "holiday",
        ]